import {
    FocusContainerDto,
    FocusContainerRefDto,
    FocusDto,
} from '../../coaching-base/general';
import { CmpsFormField, CmpsFormFields } from '../experimental.form';
import {
    createInteraction,
    interactionFormValueReverseTransformer,
    interactionFormValueTransformer,
} from '../observation-interaction/interaction.observation.form';

import { TagGroupFormValue } from './tag-group-form-value.model';

export interface TagGroupFormFields extends CmpsFormFields {
    TRACKING_ID: CmpsFormField;
    TRACKING_CHANGED: CmpsFormField;
    FOCUS_ID: CmpsFormField;
    USER_ID: CmpsFormField;
    BEHAVIOUR_ID: CmpsFormField;
    SUB_BEHAVIOUR_ID: CmpsFormField;
    METRICS: CmpsFormField;
    INTERACTIONS: CmpsFormField;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TagGroupFormFields: TagGroupFormFields = {
    TRACKING_ID: {
        name: 'trackingId',
        label: undefined,
    },
    TRACKING_CHANGED: {
        name: 'trackingChanged',
        label: undefined,
    },
    FOCUS_ID: {
        name: 'focusId',
        label: '',
    },
    USER_ID: {
        name: 'userId',
        label: '',
    },
    BEHAVIOUR_ID: {
        name: 'behaviourId',
        label: '',
    },
    SUB_BEHAVIOUR_ID: {
        name: 'subBehaviourId',
        label: '',
    },
    METRICS: {
        name: 'metrics',
        label: '',
    },
    INTERACTIONS: {
        name: 'interactions',
        label: '',
    },
};

export function createFocusContainer(
    focus?: FocusDto,
    interactionTypeId?: number,
): TagGroupFormValue {
    return {
        trackingId: Math.random(),
        trackingChanged: false,
        focusId: focus ? focus.focusId : null,
        userId: focus ? focus.userId : null,
        behaviourId: focus ? focus.behaviourId : null,
        subBehaviourId: focus ? focus.subBehaviourId : null,
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        metrics:
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            focus && focus.metrics
                ? focus.metrics.map((e) => ({
                      metricId: e,
                      metricFullName: null,
                      metricShortName: null,
                      metricInitials: null,
                      isActiveGoal: false,
                  }))
                : [],
        interactions: [createInteraction(interactionTypeId)],
    };
}

export function tagGroupFormValueModelTransformer(
    model: FocusContainerDto,
): TagGroupFormValue {
    if (!model) {
        return null;
    }
    return {
        trackingId: Math.random(),
        trackingChanged: false,
        focusId: model.focusId,
        userId: null,
        behaviourId: model.behaviourId,
        subBehaviourId: model.subBehaviourId,
        metrics: model.metrics ? [...model.metrics] : [],
        interactions: (model.interactions || []).map(
            interactionFormValueTransformer,
        ),
    };
}

export function focusContainerFormValueModelReverseTransformer(
    model: TagGroupFormValue,
): FocusContainerRefDto {
    return {
        focusId: model.focusId,
        userId: model.userId,
        behaviourId: model.behaviourId,
        subBehaviourId: model.subBehaviourId,
        metrics: model.metrics ? [...model.metrics] : [],
        interactions: (model.interactions || []).map(
            interactionFormValueReverseTransformer,
        ),
    };
}
